import { Outlet } from "react-router-dom";

/** Branded shell for /login and /register, matching the BizPandit attract-screen mark. */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen  items-center justify-center bg-surface ">
      <div className="">
         
        <Outlet />
      </div>
    </div>
  );
}
